import { useState } from "react";
import { Badge } from "react-bootstrap";

import ContainerAnimation from "components/ContainerAnimation";
import { usePatientQuote } from "providers/Quote/PatientQuote";

import PatientQuoteList from "./components/PatientQuoteList";
import PatientQuoteSearch from "./components/PatientQuoteSearch";

const PatientQuote = () => {
  const { searchData, patientQuotesTotal, patientQuotesFoundTotal } =
    usePatientQuote();

  const [selectedNavTab, setSelectedNavTab] = useState("pending-data");

  const handleTabClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    setSelectedNavTab(e.currentTarget.id);
  };

  return (
    <ContainerAnimation className="content">
      {/* Título e Pesquisa */}
      <div className="bg-white">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col col-auto">
              <h1>Orçamentos</h1>
            </div>
            <div className="col col-auto">
              <PatientQuoteSearch />
            </div>
            <div className="col-12">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <span
                    id="pending-data"
                    className={`nav-link link-primary ${
                      selectedNavTab === "pending-data" && "active"
                    }`}
                    onClick={handleTabClick}
                  >
                    Orçamentos Pendentes
                    <Badge bg="primary ml-1 text-white">
                      {!Object.values(searchData).some(
                        (currentValue) => !!currentValue
                      )
                        ? patientQuotesTotal
                        : patientQuotesFoundTotal}
                    </Badge>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="tab-content">
          {selectedNavTab === "pending-data" && <PatientQuoteList />}
        </div>
      </div>
    </ContainerAnimation>
  );
};

export default PatientQuote;
